import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppraisalAccessGuard } from '../shared/guards/appraisal-access/appraisal-access.guard';
import { AuthGuard } from '../shared/guards/auth/auth.guard';
import { DocumentationAccessGuard } from '../shared/guards/documentation-access/documentation-access.guard';
import { EconomicStudyAccessGuard } from '../shared/guards/economic-study-access/economic-study-access.guard';
import { InitialStateAccessGuard } from '../shared/guards/initial-state-access/initial-state-access.guard';
import { RejectedMortgageGuard } from '../shared/guards/rejected-mortgage/rejected-mortgage.guard';
import { ResultAccessGuard } from '../shared/guards/result-access/result-access.guard';
import { SignAccessGuard } from '../shared/guards/sign-access/sign-access.guard';
import {
  APPRAISAL_NAME,
  DOCUMENTATION_NAME,
  ECONOMIC_STUDY_NAME,
  ERROR_NAME,
  RESULT_NAME,
  ROOT_NAME,
  SIGN_IN_NAME,
  WALL_NAME,
} from '../shared/utils/constants';
import { AdvanceSimulatorComponent } from './containers/advance-simulator/advance-simulator.component';
import { AppraisalComponent } from './containers/appraisal/appraisal.component';
import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { DocumentationComponent } from './containers/documentation/documentation.component';
import { ErrorComponent } from './containers/error/error.component';
import { LayoutComponent } from './containers/layout/layout.component';
import { ResultComponent } from './containers/result/result.component';
import { SignatureComponent } from './containers/signature/signature.component';
import { WallContainerComponent } from './containers/wall-container/wall-container.component';

const routes: Routes = [
  {
    path: ROOT_NAME,
    component: LayoutComponent,
    children: [
      {
        path: ROOT_NAME,
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ECONOMIC_STUDY_NAME,
        component: AdvanceSimulatorComponent,
        canActivate: [
          AuthGuard,
          InitialStateAccessGuard,
          EconomicStudyAccessGuard,
          RejectedMortgageGuard,
        ],
      },
      {
        path: DOCUMENTATION_NAME,
        component: DocumentationComponent,
        canActivate: [
          AuthGuard,
          InitialStateAccessGuard,
          DocumentationAccessGuard,
          RejectedMortgageGuard,
        ],
      },
      {
        path: APPRAISAL_NAME,
        component: AppraisalComponent,
        canActivate: [
          AuthGuard,
          InitialStateAccessGuard,
          AppraisalAccessGuard,
          RejectedMortgageGuard,
        ],
      },
      {
        path: `${APPRAISAL_NAME}/:status`,
        component: AppraisalComponent,
        // canActivate: [AuthGuard, InitialStateAccessGuard, AppraisalAccessGuard, RejectedMortgageGuard]
      },
      {
        path: SIGN_IN_NAME,
        component: SignatureComponent,
        canActivate: [AuthGuard, InitialStateAccessGuard, SignAccessGuard],
      },
      {
        path: RESULT_NAME,
        component: ResultComponent,
        canActivate: [
          AuthGuard,
          InitialStateAccessGuard,
          ResultAccessGuard,
          RejectedMortgageGuard,
        ],
      },
      {
        path: WALL_NAME,
        component: WallContainerComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ERROR_NAME,
        component: ErrorComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: ROOT_NAME,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MortgageRoutingModule {}
